import type { Bcp47Locale, Locale } from '@backmarket/core-types/Locale'

/**
 * Converts a BCP-47 locale (e.g. "en-us", "zh-hans") into
 * a POSIX/ICU-style locale (e.g. "en_US", "zh_HANS").
 * *
 * @example toPosixLocale("en-us")   // "en_US"
 * @example toPosixLocale("zh-hans") // "zh_HANS"
 * @example toPosixLocale("fr-ca")   // "fr_CA"
 */
export function toPosixLocale(locale: Bcp47Locale): Locale {
  // `language` should be a 2-letter ISO 639-1 code (e.g., "en", "fr", "zh")
  // `languageCountryOrScript` should be either:
  //   - 2 letters: ISO 3166-1 alpha-2 country code (e.g., "US", "FR")
  //   - 4 letters: ISO 15924 script code (e.g., "HANS", "HANT")
  const match = locale.match(
    /^(?<language>[a-zA-Z]{2})-(?<languageCountryOrScript>[a-zA-Z]{2,4})$/,
  )

  if (!match) {
    throw new Error(`Invalid locale: ${locale}`)
  }

  return `${match.groups?.language.toLowerCase()}_${match.groups?.languageCountryOrScript.toUpperCase()}` as Locale
}
